// `?share=1` — "open this screen's share flow on arrival". Read by Settings (opens the Share-the-app
// modal; the credits card's Earn button and the invite card's "See your invites" land there, and the
// `symphony.wix.app/share` app link resolves to it) and by a pack's screen (starts that pack's share
// flow; the in-chat "Share this pack" card lands there).
//
// Import-free so it is testable without the app graph; the React binding is `use-share-on-arrival.ts`.

export const SHARE_ON_ARRIVAL_PARAM = 'share';

type Query = Record<string, string | string[] | undefined>;

/** Whether a route's query asks to open the share flow on arrival. Only the literal `1` counts. */
export function wantsShareOnArrival(query: Query): boolean {
  const value = query[SHARE_ON_ARRIVAL_PARAM];
  return (Array.isArray(value) ? value[0] : value) === '1';
}

/**
 * The same query without the flag, so a reload or a Back into the screen does not open the flow a
 * second time — the flag is a one-shot instruction, not state.
 */
export function withoutShareParam(query: Query): Query {
  const { [SHARE_ON_ARRIVAL_PARAM]: _dropped, ...rest } = query;
  void _dropped;
  return rest;
}
